import { createAsyncThunk } from "@reduxjs/toolkit";
import openApi from "services/apis/openApi";

export const fetchCompanyDetails = createAsyncThunk(
  "comapny/fetchDetails",
  async (companyDomain, thunkAPI) => {
    try {
      const response = await openApi.getCompanyInformationByDomainName({
        domainName: companyDomain,
      });
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);
